export const ALLOWED_API_VERSIONS = ['2021-01-01', '2022-09-26', '2023-03-15', '2024-06-01'];
export const DEFAULT_API_VERSION = '2021-01-01';
export const APP_VERSION = 'v2';
